import type { SchemaLocales } from '@based'

export const LANGUAGES = {
  en: 'English',
  sq: 'Albanian',
  hy: 'Armenian',
  az: 'Azerbaijani',
  bg: 'Bulgarian',
  hr: 'Croatian',
  cs: 'Czech',
  da: 'Danish',
  nl: 'Dutch',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  ka: 'Georgian',
  de: 'German',
  el: 'Greek',
  he: 'Hebrew',
  it: 'Italian',
  lv: 'Latvian',
  lt: 'Lithuanian',
  lb: 'Luxembourgish',
  mt: 'Maltese',
  cnr: 'Montenegrin', // ISO 639‑2
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  sr: 'Serbian',
  es: 'Spanish',
  sv: 'Swedish',
  uk: 'Ukrainian',
}

export const locales: SchemaLocales = Object.fromEntries(
  Object.keys(LANGUAGES).map((iso) => {
    return [iso, { required: true, fallback: ['en'] }]
  }),
)
